import { GeoBlock } from '../../components/GeoBlock';
import { useGeneralInfo } from '../../hooks';

export const GeoBlockContainer = () => {
  const { geo } = useGeneralInfo();

  if (!geo?.geoLabels.length) {
    return null;
  }

  return <GeoBlock geoLabels={geo.geoLabels} />;
};
